<template lang="pug">
div.wrap-module-studio
  div(v-show="isCapturing && showUI").wrap-capture
    ItemCaptureFrame(:frame="frame"
      :assets="assets" :objects="objects"
      @stopCapturing="isCapturing = false")

  div(v-show="!isCapturing && showUI").wrap-ui
    div(v-if="isSaving").wrap-saving-line
      v-progress-linear(:color="pallete.$active_color" indeterminate)

    div.wrap-left-top-menu.f.fm.pl3
      //- v-icon(@click="this.$router.push(comicPagePath)" size="32px").mr8 mdi-arrow-left
      v-icon(@click="$router.push(pagePath)"
        :color="pallete.$active_color" size="32px").mr12 mdi-trackpad
      div(@click="isCapturing = true"
        :data-tg-tour="tgCaptureFrame.tour"
        :data-tg-order="tgCaptureFrame.order"
        :data-tg-group="tgCaptureFrame.group"
        ).btn-capture.f.fm.px10.py8.cursor-pointer.mr12
        v-icon(dark).mr6 mdi-selection
        span.fz14.bold.pb2 コマに変換
      ItemToolSelector(ref="itemToolSelector"
        :currentMode="currentMode"
        :targetObjectMode="targetObjectMode"
        :tutorial="tutorial"
        @setTranformControlsMode="setTranformControlsMode")

    ItemAssetsManager(:assets="assets" :frame="frame" :tutorial="tutorial"
      :assetLoadingProgresses="assetLoadingProgresses"
      @dropObject="dropObject")

    div(v-if="!targetObject && showUI").wrap-object-list
      div.wrap-tab-header.f
        div(v-for="tab in sceneControllerTabContents"
          @click="sceneControllerTab = tab"
          :style="`width: ${100 / sceneControllerTabContents.length}%;`"
          :class="{'active': tab.name == sceneControllerTab.name}").tab.f.fh.py8.cursor-pointer
          span.fz12 {{tab.label}}
      div(v-show="sceneControllerTab.name === 'objects'")
        ItemObjectList(:objects="objects" :assets="assets"
          :loadingStatusesInObjectList="loadingStatusesInObjectList"
          :isInitialized="isInitialized"
          @setTargetObjectByObjectDocId="setTargetObjectByObjectDocId"
          @setObjectInvisible="setObjectInvisible"
          @setObjectLocked="setObjectLocked")
      div(v-show="sceneControllerTab.name === 'scene'")
        ItemSceneSettings(ref="itemSceneSettings"
          v-if="scene && frame && ambientLight"
          :ambientLight="ambientLight"
          :cameraFov="cameraFov" :cameraNearFar="cameraNearFar"
          :scene="scene" :frame="frame"
          @toggleTonePass="toggleTonePass"
          @updateAmbientLightIntensity="updateAmbientLightIntensity"
          @updateCameraFov="updateCameraFov"
          @updateCameraNearFar="updateCameraNearFar"
          @updateSceneBackgroundColor="updateSceneBackgroundColor"
          @updateComicalConvertPassThrehold="updateComicalConvertPassThrehold")

    div(v-if="showObjectController && targetObject && showUI").wrap-object-controller
      div.wrap-back-to-object-list.f.fh.py6
        v-icon(@click="targetObject = null" dark) mdi-chevron-left
      ItemObjectInfo(:asset="targetAsset" :targetObject="targetObject"
        @removeObject="removeObject")
      div.wrap-tab-header.f
        div(v-for="tab in objectControllerTabContents"
          @click="objectControllerTab = tab"
          :style="`width: ${100 / objectControllerTabContents.length}%;`"
          :class="{'active': tab.name == objectControllerTab.name}").tab.f.fh.py8.cursor-pointer
          span.fz12 {{tab.label}}
      div(v-show="objectControllerTab.name == 'transform'").wrap-transform-changer.mb4
        ItemObjectTransformChanger(v-if="targetAsset && targetObject"
          ref="itemObjectTransformChanger"
          :targetObject="targetObject" :targetObjectMode="targetObjectMode"
          :targetAsset="targetAsset" :objects="objects"
          @setTargetObjectTransformProps="setTargetObjectTransformProps")
      div(v-show="objectControllerTab.name == 'pose'").wrap-pose-changer
        ItemPoseChanger(ref="itemPoseChanger"
          v-if="['actor'].includes(targetAsset.type)"
          :targetObject="targetObject" :objects="objects"
          :vrm="targetObject.userData.vrm"
          :transformControls="transformControlsForPose"
          :clock="clock"
          @updateBoneProp="updateBoneProp"
          @updateBlendShapeProp="updateBlendShapeProp")
      div(v-show="objectControllerTab.name == 'expression'").wrap-expression-changer
        ItemExpressionChanger(v-if="['actor'].includes(targetAsset.type)"
          :clock="clock"
          :targetObject="targetObject" :objects="objects"
          @updateEyesBoneProp="updateEyesBoneProp"
          @updateBlendShapeProp="updateBlendShapeProp"
          @addCustomTextureToVRM="addCustomTextureToVRM"
          @removeCustomTextureFromVRM="removeCustomTextureFromVRM"
          @updateObjectDoc="updateObjectDoc")
      div(v-show="objectControllerTab.name == 'effect'").wrap-effect-changer
        ItemObjectEffectChanger(
          v-if="['actor', '3d_stage', '3d_object'].includes(targetAsset.type)"
          :clock="clock"
          :targetObject="targetObject" :objects="objects"
          :targetAsset="targetAsset"
          @addObjectOpacityEffect="addObjectOpacityEffect"
          @updateObjectOpacityEffect="updateObjectOpacityEffect"
          @removeObjectOpacityEffect="removeObjectOpacityEffect"
          @addObjectOutlineEffect="addObjectOutlineEffect"
          @updateObjectOutlineEffect="updateObjectOutlineEffect"
          @removeObjectOutlineEffect="removeObjectOutlineEffect"
          @updateEmissiveColor="updateEmissiveColor"
          @updateVrmOutlineWidth="updateVrmOutlineWidth"
          @updateHairWind="updateHairWind" @resetHairWind="resetHairWind"
          @updateObjectDoc="updateObjectDoc"
          @deleteObjectDocField="deleteObjectDocField")

  //- div.wrap-canvas
    div(ref="wrapCanvas" @pointerup="onCanvas" @touchend="onCanvas")
    div(ref="wrapStats")
  //- div(@mouseup="onCanvas" @touchend="onCanvas").wrap-canvas
    div(ref="wrapCanvas" @click="onCanvas" @touchstart="onCanvas")
    div(ref="wrapStats")
  //- div(@mousedown="onCanvas" @touchstart="onCanvas").wrap-canvas
    div(ref="wrapCanvas" @click="onCanvas" @touchstart="onCanvas")
    div(ref="wrapStats")
  //- div(style="cursor: none;").wrap-canvas
  div.wrap-canvas
    //- div(ref="wrapCanvas"
      @mousedown="onCanvas" @touchstart="onCanvas")
    div(ref="wrapCanvas"
      @mousedown="clickStartTime = new Date()" @touchstart="clickStartTime = new Date()"
      @mouseup="onCanvas($event)" @touchend="onCanvas($event)")
    div(ref="wrapStats")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
.wrap-module-studio {
  position: relative;
  width: 100%; height: $device_height;
  overflow: hidden;
  .wrap-ui {
    .wrap-saving-line {
      position: fixed;
      top: 0; width: 100%;
    }
    .wrap-left-top-menu {
      position: absolute;
      top: $studio_basic_margin; left: $studio_basic_margin;
      .btn-capture {
        background: $active_color;
        border-radius: 3px;
        box-shadow: $box_shadow;
        span {
          white-space: nowrap;
          color: $dark_primary_text_color;
        }
      }
    }
    .wrap-toggle-object-controller {
      position: absolute;
      right: $studio_basic_margin; top: $studio_basic_margin;
    }
    .wrap-object-list, .wrap-object-controller {
      position: absolute;
      top: $studio_basic_margin; right: $studio_basic_margin;
      max-height: calc(#{$device_height} - (#{$studio_basic_margin} * 2));
      background: $overlay_color;
      border-radius: 3px;
      box-shadow: $box_shadow;
      .wrap-back-to-object-list, .wrap-hide {
        position: absolute;
        width: 18px;
        left: -17px; top: 0px;
        background: $overlay_color;
      }
      .wrap-tab-header {
        .tab {
          color: $dark_primary_text_color;
          border-bottom: solid 0.8px $dark_primary_text_color;
          &.active {
            font-weight: bold;
            color: $active_color;
            border-bottom: solid 0.8px $active_color;
          }
        }
      }
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import studioManager from '@/components/mixin/studioManager'
import vrmManager from '@/components/mixin/vrmManager'
import gltfManager from '@/components/mixin/gltfManager'
import * as THREE from 'three'
import Stats from 'three/examples/jsm/libs/stats.module'
import { SimplifyModifier } from 'three/examples/jsm/modifiers/SimplifyModifier'
// import { VRM, VRMSchema } from '@pixiv/three-vrm'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { DragControls } from 'three/examples/jsm/controls/DragControls'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls'
// import { DragControls } from "@/plugins/DragControls"
import { ObjectControls } from 'threejs-object-controls'
// import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
// import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js'
// import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
// import { ComicalConvertionShader } from '@/shader/comicalConvertion'
// import { bones, blendShapes, leftHandBones, rightHandBones, eyesBones } from '@/plugins/vrm-nums'
// import { simplifyMesh } from '@/plugins/simplifyModifier/index'
import ItemAssetsManager from '@/components/item/studio/ItemAssetsManager'
import ItemObjectList from '@/components/item/studio/ItemObjectList'
import ItemSceneSettings from '@/components/item/studio/ItemSceneSettings'
import ItemObjectInfo from '@/components/item/studio/ItemObjectInfo'
import ItemObjectTransformChanger from '@/components/item/studio/ItemObjectTransformChanger'
import ItemPoseChanger from '@/components/item/studio/ItemPoseChanger'
import ItemExpressionChanger from '@/components/item/studio/ItemExpressionChanger'
import ItemObjectEffectChanger from '@/components/item/studio/ItemObjectEffectChanger'
import ItemCaptureFrame from '@/components/item/studio/ItemCaptureFrame'
import ItemToolSelector from '@/components/item/studio/ItemToolSelector'

export default {
  mixins: [studioManager, vrmManager, gltfManager],
  components: {
    ItemAssetsManager,
    ItemCaptureFrame,
    ItemToolSelector,
    ItemObjectList, ItemSceneSettings,
    ItemObjectInfo, ItemObjectTransformChanger, ItemPoseChanger,
    ItemExpressionChanger, ItemObjectEffectChanger
  },
  props: {
    assets: { type: Array, required: true },
    frame: { type: Object, required: true },
    tutorial: { type: Object, default: null }
  },
  computed: {
    ...mapStateAuth(['uid']),
    pagePath () {
      const rp = this.$route.params
      return `/edit-comic/${rp.comicId}/${rp.episodeId}/${rp.pageId}`
    },
    objectCollection () {
      const rp = this.$route.params
      return database.objectCollection(rp.comicId, rp.episodeId, rp.pageId, rp.frameId)
    },
    targetAsset () {
      return this.targetObject ?
        this.assets.filter(a => a.id === this.targetObject.userData.asset.id)[0] : null
    }, // eslint-disable-next-line
    targetObjectMode () {
      if (!this.targetAsset) return ''
      switch (this.targetAsset.type) {
        case 'actor':
        case '3d_object':
        case '3d_stage':
          return 'mesh'
        case 'background':
        case 'effect_background':
        case 'image_object':
        case 'onomatopoeia':
        case 'manpu':
          return 'sprite'
      }
    },
    sceneControllerTabContents () {
      return [
        { label: 'オブジェクト', name: 'objects' },
        { label: 'シーン', name: 'scene' }
      ]
    },
    objectControllerTabContents () {
      if (this.targetAsset.type === 'actor') {
        return [
          { label: '変形', name: 'transform' },
          { label: 'ポーズ', name: 'pose' },
          { label: '表情 / 顔', name: 'expression' },
          { label: 'エフェクト', name: 'effect' }
        ]
      } else {
        return [
          { label: '変形', name: 'transform' },
          { label: 'エフェクト', name: 'effect' }
        ]
      }
    }
  },
  watch: {
    targetObject (nowObject, prevObject) {
      // 他のオブジェクトが選択されたらタブのステータスをリセット
      if (prevObject && nowObject) {
        if (prevObject.uuid !== nowObject.uuid) {
          this.objectControllerTab = { label: '変形', name: 'transform' }
        }
      } else if (!prevObject) {
        this.objectControllerTab = { label: '変形', name: 'transform' }
      }
      // 選択したobjectにアウトラインをつける
      if (nowObject) {
        const pixelRatio = this.renderer.getPixelRatio()
        this.targetOutlinePass = new OutlinePass(
          new THREE.Vector2(this.canvasSize.width * pixelRatio, this.canvasSize.height * pixelRatio),
          this.scene, this.camera
        )
        // this.targetOutlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth,window.innerHeight), this.scene, this.camera)
        this.targetOutlinePass.selectedObjects = [nowObject]
        this.targetOutlinePass.renderToScreen = true
        this.targetOutlinePass.type = 'target-outline-pass'

        this.composer.addPass(this.targetOutlinePass)

        this.targetOutlinePass.edgeStrength = 3.0
        this.targetOutlinePass.edgeGlow = 1.0
        this.targetOutlinePass.visibleEdgeColor.set('rgb(29, 193, 172)') // $active_color
        this.targetOutlinePass.hiddenEdgeColor.set('rgb(29, 193, 172)')
      } else {
        this.composer.removePass(this.targetOutlinePass)
      }
    },
    isCapturing () {
      if (this.isCapturing) {
        const targetOutlinePasses = this.composer.passes
          .filter(p => p.type === 'target-outline-pass')
        targetOutlinePasses.map(t => {
          this.composer.removePass(t)
        })
        // if (this.targetOutlinePass) this.composer.removePass(this.targetOutlinePass)

        this.horizonalFloor.visible = false
        if (this.transformControls.object) this.transformControls.detach()
        if (this.transformControlsForPose) this.transformControlsForPose.detach()
      } else {
        if (this.targetOutlinePass) this.composer.addPass(this.targetOutlinePass)

        this.horizonalFloor.visible = true

        if (this.targetObject) {
          const itemPoseChanger = this.$refs.itemPoseChanger
          if (itemPoseChanger && itemPoseChanger.showAdjustPose) {
            itemPoseChanger.attachJointToTransformControls()
          } else {
            this.transformControls.attach(this.targetObject)
          }
        }
      }
    },
  },
  data () {
    return {
      isSaving: false,
      isInitialized: false,
      isCapturing: false, showUI: true,
      showObjectController: true,
      sceneControllerTab: { label: 'オブジェクト', name: 'objects' },
      objectControllerTab: { label: '変形', name: 'transform' },
      // for tools
      currentMode: 'normal',
      // for canvas
      stats: null,
      renderer: null, scene: null, clock: null, frameRateCount: 0,
      camera: null, cameraFov: null, cameraNearFar: [],
      orbitControls: null,
      transformControls: null, transformControlsForPose: null,
      transformControlsMode: 'normal',
      saveByTranfromControlsTimer: null,
      light: null, ambientLight: null,
      orbitControlsDragStartedAt: null,
      canvasSize: null, onResizeTimer: null,
      stageSize: 10,
      raycaster: null,
      raycasterTargetSprite: null, raycasterTargetSphere: null,
      ray: null,
      // composer: null, renderPass: null, thresholdPass: null,
      // comicalConvertPass: null, comicalShaderThrehold: [],
      outlinePasses: [],
      objects: [],
      targetObject: null, targetBBox: null, targetBCube: null,
      lineGroupsForOutline: [],
      targetOutlinePass: null,
      assetLoadingProgresses: [], loadingStatusesInObjectList: [],
      updateTargetObjectTimer: null, updatePoseTimer: null,
      updateEyesBoneTimer: null, updateBlendShapeTimer: null,
      saveDuration: 3000,
      bboxes: [], bCubes: [], bCubeGroups: [],
      sprites: [],
      dragControls: null,draggingObject: null,
      rotateObjectControls: null, rotatingObject: null,
      previousBBoxPosition: null,
      horizonalFloor: null,
      // others
      frameId: null,
      clickStartTime: null,
      // tutorial
      tgCaptureFrame: {
        tour: [
          '<p class="mb10">配置や変形が終わったらカメラを操作してコマをキャプチャしましょう！</p>',
          '<p class="mb10">右クリックを押しながらドラッグをするとカメラを移動（パン）させることができます。</p>',
          '<p class="mb20">* コマのキャプチャ中もカメラの操作（移動・回転）は可能です！</p>',
          // '<iframe style="border-radius: 3px;" height="201" src="https://www.youtube.com/embed/SLIGmkMiy08?loop=1&playlist=SLIGmkMiy08&autoplay=1&mute=1&showinfo=0&rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
          '<video loop muted autoplay playsinline controls class="w-full">'
              + '<source src="/tutorial/tools_in_studio3.mp4" type="video/mp4">'
              + '</video>'
        ].join(''),
        order: '3', group: 'tools_in_studio'
      }
    }
  },
  async mounted () {
    window.addEventListener('resize', this.onResize)
    window.addEventListener('keydown', this.keydown)

    this.canvasSize = {
      width: this.$el.clientWidth,
      height: this.$el.clientHeight
    }

    // this.stats = Stats()
    // document.body.appendChild(this.stats.dom)

    this.objects = await this.objectCollection.getObjects()
    // console.log('this.objects:', this.objects)

    // for saveScene
    this.frameId = this.$route.params.frameId

    this.initializeScene()
  },
  async beforeDestroy () {
  // async beforeUnmount () {
    await this.saveScene()
    this.disposeScene({ renderer: this.renderer, scene: this.scene })
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('keydown', this.keydown)
    this.orbitControls.dispose()
  },
  methods: {
    setTargetObjectByObjectDocId (objectDocId) {
      // すでに選択済みの場合は反映させない
      if (this.targetObject && this.targetObject.userData.docId === objectDocId) {
        return
      }

      this.targetObject = this.scene.children
        .filter(c => c.userData.docId === objectDocId)[0]
      
      this.attachTargetObjectToTransformControls()
      this.transformControlsForPose.detach()
    },
    setTranformControlsMode (mode) {
      if (mode === 'rotate' && this.targetObjectMode === 'sprite') return

      this.currentMode = mode
      this.transformControlsMode = mode
      if (this.targetObject) {
        if (mode === 'normal') {
          this.transformControls.detach()
        } else {
          this.transformControls.setMode(mode)
          this.transformControls.attach(this.targetObject)
        }
      }
    },
    attachTargetObjectToTransformControls () {
      if (this.targetObject 
        && this.transformControlsMode !== 'normal') {
        if (this.targetObjectMode === 'sprite' && this.currentMode === 'rotate') {
          this.currentMode = 'normal'
          this.transformControls.detach()
        } else {
          this.transformControls.setMode(this.currentMode)
          this.transformControls.attach(this.targetObject)
        }
      }
    },
    // for canvas
    async initializeScene () {
      this.scene = new THREE.Scene()

      // レンダラーの設定
      this.renderer = this.createRenderer({ 
        size: {
          width: this.canvasSize.width,
          height: this.canvasSize.height
        }
      })

      if (this.frame.scene && this.frame.scene.backgroundColor) {
        const sceneBgColor = this.frame.scene.backgroundColor
        const bgColor = new THREE.Color(sceneBgColor.r, sceneBgColor.g, sceneBgColor.b)
        this.updateSceneBackgroundColor(bgColor)
      }

      // this.renderer.setClearColor(0xffffff, 1)
      // this.renderer.shadowMap.enabled = true
      // this.scene.background = new THREE.Color(0xffffff)

      // this.renderer.setPixelRatio(1) // https://ics.media/entry/12930/ GPUの対応に応じて下げる？
      this.$refs.wrapCanvas.appendChild(this.renderer.domElement)

      // カメラの設定
      this.cameraFov = (this.frame.scene && this.frame.scene.camera.fov) ? 
        this.frame.scene.camera.fov : this.defaultCameraFov
      this.cameraNearFar = (this.frame.scene && this.frame.scene.camera.nearFar) ?
        this.frame.scene.camera.nearFar : this.defaultCameraNearFar
      this.camera = new THREE
        .PerspectiveCamera(this.cameraFov,
          this.canvasSize.width / this.canvasSize.height,
          this.cameraNearFar[0], this.cameraNearFar[1])
      const cameraPos = this.frame.scene ?
        this.toVector3(this.frame.scene.camera.position) : new THREE.Vector3(0, 1.0, 3.5)
      this.camera.position = cameraPos

      // カメラコントーロールの設定
      this.orbitControls = new OrbitControls(this.camera, this.renderer.domElement)
      const controlsTarget = this.frame.scene ?
        this.toVector3(this.frame.scene.orbitControls.target) : new THREE.Vector3(0, 1.0, 0)
      this.orbitControls.target = controlsTarget
      this.orbitControls.screenSpacePanning = true
      this.orbitControls.addEventListener('start', () => {
        this.orbitControlsDragStartedAt = new Date()
      })

      // zoomの距離が近づきすぎたら変化するように調整
      const retargetByZoomDistance = () => {
        // カメラの現在位置を取得
        const cameraPosition = this.camera.position.clone()
        const targetPosition = this.orbitControls.target.clone()
        const distFromCameraToTarget = cameraPosition.distanceTo(targetPosition)
        let additionalDistance
        if (distFromCameraToTarget < 2 || distFromCameraToTarget > 7) {
          if (distFromCameraToTarget < 2) additionalDistance = 0.4
          if (distFromCameraToTarget > 7) additionalDistance = -0.4
          const direction = this.orbitControls.target.clone().sub(this.camera.position)
          direction.normalize()
          const offset = direction.clone().multiplyScalar(additionalDistance)
          this.orbitControls.target.add(offset)
          this.orbitControls.update()
        }
      }
      this.orbitControls.addEventListener('change', retargetByZoomDistance)
      const setTargetSpritePos = () => {
        if (this.raycasterTargetSprite) {
          // const cameraPos = this.camera.position.clone()
          // const targetPos = this.orbitControls.target.clone()
          // const getPointInBetweenByLen = (pos1, pos2, length) => {
          //   const dir = pos2.clone().sub(pos1).normalize().multiplyScalar(length)
          //   return pos1.clone().add(dir)
          // }
          // const distance = 2
          // const spritePos = getPointInBetweenByLen(cameraPos, targetPos, distance)
          // this.raycasterTargetSprite.position.copy(spritePos)

          const targetPos = this.orbitControls.target.clone()
          this.raycasterTargetSprite.position.copy(targetPos)

          // const targetPos = this.orbitControls.target.clone()
          // this.raycasterTargetSprite.position.copy(targetPos)
        }
      }
      this.orbitControls.addEventListener('end', () => {
        // 1秒以上ドラッグした時のみシーンを保存する
        const durationFromDragStart = new Date() - this.orbitControlsDragStartedAt
        if (durationFromDragStart > 1000) this.saveScene()

        // D&D用のSpriteを常にカメラに追従させる
        setTargetSpritePos()
      })
      this.orbitControls.listenToKeyEvents(window)
      this.orbitControls.keys = {
        LEFT: 'ArrowLeft', UP: 'ArrowUp',
        RIGHT: 'ArrowRight', BOTTOM: 'ArrowDown'
      }
      this.orbitControls.update()

      // TransformControlsの設定
      this.transformControls = new TransformControls(this.camera, this.renderer.domElement)

      const deactivatePan = () => {
        this.orbitControls.enablePan = false
        this.orbitControls.enableRotate = false
      }
      const activatePan = () => {
        this.orbitControls.enablePan = true
        this.orbitControls.enableRotate = true
      }
      const updateWindowParams = () => {
        if (this.saveByTranfromControlsTimer) clearTimeout(this.saveByTranfromControlsTimer)
        this.saveByTranfromControlsTimer = setTimeout(() => {
          const itemObjectTransformChanger = this.$refs.itemObjectTransformChanger
          if (itemObjectTransformChanger && this.targetObject) {
            itemObjectTransformChanger.setObjectProp()
          }
          const itemPoseChanger = this.$refs.itemPoseChanger
          if (itemPoseChanger && this.targetObject && this.targetObject.userData.vrm) {
            itemPoseChanger.updateBonePropByTransformControls()
          }
        }, 400)
        if (this.targetObject.userData && this.targetObject.userData.vrm) {
          const delta = this.clock.getDelta()
          this.targetObject.userData.vrm.update(delta)
        }
      }
      this.transformControls.addEventListener('mouseDown', deactivatePan)
      this.transformControls.addEventListener('mouseUp', activatePan)
      this.transformControls.addEventListener('objectChange', updateWindowParams)
      this.transformControls.traverse(node => node.layers.set(1))
      this.transformControls.getRaycaster().layers.set(1)

      const snapNum = 0.001
      this.transformControls.setTranslationSnap(snapNum)
      this.transformControls.setRotationSnap(snapNum)
      this.transformControls.setScaleSnap(snapNum)
      this.scene.add(this.transformControls)

      this.transformControlsForPose = new TransformControls(this.camera, this.renderer.domElement)
      this.transformControlsForPose.addEventListener('mouseDown', deactivatePan)
      this.transformControlsForPose.addEventListener('mouseUp', activatePan)
      this.transformControlsForPose.addEventListener('objectChange', updateWindowParams)
      this.transformControlsForPose.traverse(node => node.layers.set(1))
      this.transformControlsForPose.getRaycaster().layers.set(1)
      this.transformControlsForPose.setTranslationSnap(snapNum)
      this.transformControlsForPose.setRotationSnap(snapNum)
      this.transformControlsForPose.setScaleSnap(snapNum)
      this.transformControlsForPose.setMode('rotate')
      this.scene.add(this.transformControlsForPose)

      // this.transformControlsForPose = new TransformControls(this.camera, this.renderer.domElement)
      // this.transformControlsForPose.copy(this.transformControls)
      // this.scene.add(this.transformControlsForPose)

      // clock
      this.clock = new THREE.Clock()

      // ライトの設定
      this.light = new THREE.DirectionalLight(0xffffff)
      const lightPosition = this.frame.scene ?
        this.toVector3(this.frame.scene.light.position) : new THREE.Vector3(0, 2, 0)
      this.light.position = lightPosition
      this.light.position.normalize()
      this.light.intensity = this.defaultDirectionalLightIntensity
      this.light.castShadow = true
      this.light.shadow.mapSize.height = 4096
      this.light.shadow.mapSize.width = 4096
      this.scene.add(this.light)

      this.ambientLight = new THREE.AmbientLight(0xffffff)
      this.ambientLight.intensity = (this.frame.scene && this.frame.scene.ambientLight) ?
        this.frame.scene.ambientLight.intensity : this.defaultAmbientLightIntensity
      this.scene.add(this.ambientLight)

      // レイキャスターの設定
      this.raycaster = new THREE.Raycaster()
      this.raycaster.near = 1.5
      this.raycaster.far = 50

      const comicalShaderThrehold = (this.frame.scene && this.frame.scene.comicalShaderThrehold) ?
        { x: this.frame.scene.comicalShaderThrehold[1], y: this.frame.scene.comicalShaderThrehold[0] } :
        { x: 0.77059, y: 0.40000 } // [0.40000, 0.77059]
      
      this.initializeComposer({
        renderer: this.renderer, scene: this.scene, camera: this.camera,
        comicalShaderThrehold: comicalShaderThrehold
      })

      const enableColorInStudio = localStorage.getItem('enableColorInStudio')
      if (enableColorInStudio && enableColorInStudio === 'color') {
        const enableColor = true
        this.toggleTonePass(enableColor)
      }

      // テスト用オブジェクト
      // const testGroup = new THREE.Group()
      // const boxGeometry = new THREE.BoxGeometry(0.5, 0.5, 0.5)
      // const boxMaterial = new THREE.MeshNormalMaterial()
      // const box = new THREE.Mesh(boxGeometry, boxMaterial)
      // const box2 = new THREE.Mesh(boxGeometry, boxMaterial)
      // box.position.set(0, 1, 0)
      // box2.position.set(0.5, 1.2, 0)
      // testGroup.add(box)
      // testGroup.add(box2)
      // this.scene.add(testGroup)

      // this.orbitControls.enabled = false
      // const boxGeometry = new THREE.BoxGeometry(0.5, 0.5, 0.5)
      // const boxMaterial = new THREE.MeshNormalMaterial()
      // const box = new THREE.Mesh(boxGeometry, boxMaterial)
      // box.position.set(0, 0, 0)
      // this.scene.add(box)
      // this.rotateObjectControls = new ObjectControls(this.camera, this.renderer.domElement, box)
      // this.rotateObjectControls.enableVerticalRotation()
      // this.rotateObjectControls.setMaxVerticalRotationAngle(Math.PI / 4, Math.PI / 4)
      // this.rotateObjectControls.setRotationSpeed(0.05)

      // const lineMaterial = new THREE.LineBasicMaterial({
      //   color: 0x000000
      // })
      // const points = []
      // points.push( new THREE.Vector3(-10, 0, 0))
      // points.push( new THREE.Vector3(0, 10, 0))
      // points.push( new THREE.Vector3(10, 0, 0))
      // const lineGeometry = new THREE.BufferGeometry().setFromPoints(points)
      // const line = new THREE.Line(lineGeometry, lineMaterial)
      // this.scene.add(line)

      // グリッドを表示
      // const gridHelper = new THREE.GridHelper(this.stageSize, this.stageSize)
      // gridHelper.layers.set(1)
      // this.scene.add(gridHelper)
      // gridHelper.visible = true

      // 座標軸を表示
      // const axesHelper = new THREE.AxesHelper(0.5)
      // axesHelper.layers.set(1)
      // this.scene.add(axesHelper)

      // オブジェクトドロップ時にraycasterで当てる用のカメラに追従するspriteを設置
      const spriteMat = new THREE.SpriteMaterial()
      // const spriteMat = new THREE.SpriteMaterial({color: 0xff0000})
      // spriteMat.opacity = 0.1
      this.raycasterTargetSprite = new THREE.Sprite(spriteMat)
      this.raycasterTargetSprite.scale.set(100, 100, 100)
      // this.raycasterTargetSprite.scale.set(1, 1, 1)
      this.raycasterTargetSprite.visible = false
      setTargetSpritePos()
      this.scene.add(this.raycasterTargetSprite)

      // const sphereMat = new THREE.MeshBasicMaterial({color: 0x00ff00})
      const sphereMat = new THREE.MeshBasicMaterial()
      // const sphereGeom = new THREE.SphereGeometry(this.stageSize/2, this.stageSize/2, this.stageSize/2)
      const sphereGeom = new THREE.SphereGeometry(this.stageSize, this.stageSize, this.stageSize)
      this.raycasterTargetSphere = new THREE.Mesh(sphereGeom, sphereMat)
      this.raycasterTargetSphere.material.side = THREE.BackSide
      this.raycasterTargetSphere.visible = false
      this.scene.add(this.raycasterTargetSphere)

      // 床の追加
      const horizonalFloorGeom = new THREE.PlaneGeometry(200, 200)
      const horizonalFloorMat = new THREE.MeshBasicMaterial({color: 0x000000, side: THREE.DoubleSide})
      // horizonalFloorMat.opacity = 0.1
      horizonalFloorMat.opacity = 0.1
      horizonalFloorMat.transparent = true
      this.horizonalFloor = new THREE.Mesh(horizonalFloorGeom, horizonalFloorMat)
      this.horizonalFloor.rotation.set(Math.PI/2, 0, 0)
      this.scene.add(this.horizonalFloor)

      // アニメーションを開始
      this.tick()

      // 追加されていたobjectを全てロード
      for (let i=0; i < this.objects.length; i++) {
        const baseAsset = this.assets
          .filter(a => a.id === this.objects[i].assetId)[0]
        switch (baseAsset.type) {
          case 'actor':
            this.addActor({
              asset: baseAsset,
              object: this.objects[i],
              isDropped: false
            })
            break
          case '3d_stage':
          case '3d_object':
            this.add3DObject({
              asset: baseAsset,
              object: this.objects[i],
              isDropped: false
            })
            break
          case 'background':
          case 'effect_background':
          case 'image_object':
          case 'onomatopoeia':
          case 'manpu':
            this.addSpriteImage({ 
              asset: baseAsset,
              object: this.objects[i],
              isDropped: false
            })
            break
        }
      }
      this.isInitialized = true
    },
    tick () {
      requestAnimationFrame(this.tick)
      // const delta = this.clock.getDelta()

      // フレームレートを落とす
      this.frameRateCount++
      if (this.frameRateCount % 2 === 0) return
      if (this.frameRateCount > 120) this.frameRateCount = 0
      
      this.bboxes.map(b => b.update())

      for (let i=0; i < this.scene.children.length; i++) {
        const child = this.scene.children[i]

        // 当たり判定用のboxを中身のオブジェクトに常に追従させる
        if (child.userData.isBCubeGroup) {
          const bBoxGroup = child
          const innerObject = this.scene.children
            .filter(c => c.uuid === bBoxGroup.userData.innerObjectUuid)[0]
          // グループをドラッグ中or開店中は中のオブジェクトの座標は更新しない
          if (innerObject &&
            !(this.draggingObject && this.draggingObject.uuid === bBoxGroup.uuid) &&
            !(this.rotatingObject && this.rotatingObject.uuid === bBoxGroup.uuid)
            ) {
            bBoxGroup.position.copy(innerObject.position)
            bBoxGroup.rotation.copy(innerObject.rotation)
            bBoxGroup.scale.copy(innerObject.scale)
          }
        }

        // 3dモデルの線画用のlineGroupは3dモデルとtransformを常に一致させる 
        if (child.userData.isLineGroupAttachedTo3DModel) {
          const attachingObject = this.scene.children
            .filter(c => c.uuid === child.userData.modelUuid)[0]
          if (attachingObject) {
            child.position.copy(attachingObject.position)
            child.rotation.copy(attachingObject.rotation)
            child.scale.copy(attachingObject.scale)
            child.visible = attachingObject.visible
          }
        }
      }
      
      this.renderWithLayers({
        renderer: this.renderer, scene: this.scene, camera: this.camera
      })
      
      // this.composer.render(this.scene, this.camera)
      // this.renderer.render(this.scene, this.camera)
      if (this.stats) this.stats.update()

      // デモ用
      // this.orbitControls.autoRotate = true
      // this.orbitControls.autoRotateSpeed = 6
      // this.orbitControls.update()
    },
    onResize () {
      if (this.onResizeTimer) clearTimeout(this.onResizeTimer)
      this.onResizeTimer = setTimeout(this.resizeCanvas, 400)
    },
    resizeCanvas () {
      this.canvasSize = {
        width: this.$el.clientWidth,
        height: this.$el.clientHeight
      }
      if (this.renderer && this.camera) {
        // カメラのアスペクト比を正す
        this.camera.aspect = this.canvasSize.width / this.canvasSize.height
        this.camera.updateProjectionMatrix()

        const pixelRatio = this.renderer.getPixelRatio()
        this.renderer.setPixelRatio(pixelRatio)
        this.renderer.setSize(this.canvasSize.width, this.canvasSize.height)
        this.resizeComposer({ 
          canvasSize: this.canvasSize, renderer: this.renderer
        })
      }
    },
    // load & add Object
    async dropObject ({ asset, dropPosition }) {
      this.targetObject = null

      const position = new THREE.Vector2()
      position.x = (dropPosition.x / window.innerWidth) * 2 - 1
      position.y = -(dropPosition.y / window.innerHeight) * 2 + 1
      
      const raycaster = new THREE.Raycaster()
      raycaster.setFromCamera(position, this.camera)

      let targetObjects = []
      if (['background', 'effect_background'].includes(asset.type)) {
        targetObjects.push(this.raycasterTargetSphere)
      } else if (['actor', '3d_stage', '3d_object', 'image_object', 'onomatopoeia', 'manpu'].includes(asset.type)) {
        targetObjects.push(this.raycasterTargetSprite)
      }
      const intersects = raycaster.intersectObjects(targetObjects)
      const target = intersects[0]
      // const target = intersects
      //   .filter(i => i.object.uuid === this.raycasterTargetSprite.uuid)[0]
      
      // targetの座標テスト用
      // if (target) {
      //   const boxGeometry = new THREE.BoxGeometry(0.2, 0.2, 0.2)
      //   const boxMaterial = new THREE.MeshBasicMaterial({color: 0x0000ff})
      //   const box = new THREE.Mesh(boxGeometry, boxMaterial)
      //   box.position.copy(target.point)
      //   console.log('target:', target)
      //   console.log('box.position:', box.position)
      //   this.scene.add(box)
      // }
      
      if (!target) {
        this.$root.$emit('showNavigationMessage', {
          message: '設置範囲外です。もう少し中央に設置してください', showOK: true
        })
        return
      }

      // 小数点切り捨て
      const truncatingDigits = 10
      target.point.x = Math.round(target.point.x * truncatingDigits) / truncatingDigits
      target.point.y = Math.round(target.point.y * truncatingDigits) / truncatingDigits
      target.point.z = Math.round(target.point.z * truncatingDigits) / truncatingDigits
      
      this.assetLoadingProgresses.push({
        progress: 0, assetId: asset.id
      })
      
      switch (asset.type) {
        case 'actor':
          this.targetObject = await this.addActor({ asset, target, isDropped: true })
          break
        case '3d_stage':
        case '3d_object':
          this.targetObject = await this.add3DObject({ asset, target, isDropped: true })
          break
        case 'background':
        case 'effect_background':
        case 'image_object':
        case 'onomatopoeia':
        case 'manpu':
          this.targetObject = await this.addSpriteImage({ asset, target, isDropped: true })
          break
      }

      this.assetLoadingProgresses = this.assetLoadingProgresses
        .filter(e => e.assetId !== asset.id)

      this.currentMode = 'translate'
      this.transformControls.setMode('translate')
      this.transformControls.attach(this.targetObject)
      // this.attachTargetObjectToTransformControls()

      // tutorial
      const itemToolSelector = this.$refs.itemToolSelector
      if (itemToolSelector) itemToolSelector.startTutorial()

      this.sendMixpanelEvent({ msg: 'createNewObjectInStudio', info: asset })
      return true
    },
    async addActor ({ asset, target, object, isDropped }) {
      if (!isDropped && object) this.activateLoadingStatusInObjectList(object.id)

      const progressFunc = (progress) => {
        const progressPercent = Math.floor(100.0 * (progress.loaded / progress.total))
        this.assetLoadingProgresses.map(e => {
          if (e.assetId === asset.id) e.progress = progressPercent
          return e
        })
      }
      const gltf = await this.loadGLTFwithDracoLoader({ path: asset.assetURL, progressFunc })
      this.removeUnnecessaryElementsFromVRM({ gltf })
      const vrm = gltf.userData.vrm

      // gltf.userData.vrm.scene.userData.vrm = gltf.userData.vrm
      // const vrm = await VRM.from(gltf).then(vrm => vrm)

      // VRM1.0はすでにSurprisedとか追加されているっぽい
      // Surprisedなどのの表情を追加
      // const unkownBlendShapeGroups = vrm.blendShapeProxy.unknownGroupNames
      // for (let i=0; i < unkownBlendShapeGroups.length; i++) {
      //   const unknownBlendShapeGroup = vrm.blendShapeProxy
      //     .getBlendShapeGroup(unkownBlendShapeGroups[i])
      //   vrm.blendShapeProxy.registerBlendShapeGroup(
      //     unkownBlendShapeGroups[i],
      //     // 'unknown',
      //     unkownBlendShapeGroups[i],
      //     unknownBlendShapeGroup)
      //   // console.log('unknownBlendShapeGroup:', unknownBlendShapeGroup)
      // }

      this.registerCustomExpression(vrm)

      this.addMargineBoxForRaycaster(vrm.scene, 'vrm')

      const delta = this.clock.getDelta()
      let docId
      if (isDropped) {
        // ドラッグ&ドロップで新規作成した場合
        const box = new THREE.Box3().setFromObject(vrm.scene)
        const vrmYOffset = (box.max.y - box.min.y) / 2
        // 床に近い場合は床に接触して配置させる
        const initialVrmPosY = target.point.y - vrmYOffset
        if (Math.abs(this.horizonalFloor.position.y - initialVrmPosY) < 1) {
          vrm.scene.position.set(
            target.point.x,
            this.horizonalFloor.position.y,
            target.point.z)
        } else {
          vrm.scene.position.set(target.point.x, initialVrmPosY, target.point.z)
        }
        
        const initialScale = 1.0
        vrm.scene.scale.set(initialScale, initialScale, initialScale)
        
        if (!this.isVRM1({ vrm })) vrm.scene.rotation.set(0, Math.PI, 0)

        const vrmObj = {
          assetId: asset.id,
          position: this.toPosition(vrm.scene.position), // { x: 0, y: 0, z: 0 },
          rotation: this.toRotation(vrm.scene.rotation), // { x: 0, y: 0, z: 0 },
          scale: this.toScale(vrm.scene.scale),
          // プロパティをコピー
          pose: JSON.parse(JSON.stringify(this.initialVrmPose)),
          blendShape: JSON.parse(JSON.stringify(this.initialVrmBlendShape)),
          createdBy: this.uid,
          createdAt: new Date(), updatedAt: new Date()
        }
        this.updateBlendShape({ vrm, blendShape: vrmObj.blendShape, delta })
        this.updatePose({ vrm, pose: vrmObj.pose, delta })
        
        docId = await this.objectCollection.add(vrmObj)
        vrmObj.id = docId
        this.objects.push(vrmObj)
      } else if (object && !isDropped) {
        // object collectionからロードした場合
        vrm.scene.position.set(object.position.x, object.position.y, object.position.z)
        vrm.scene.rotation.set(object.rotation.x, object.rotation.y, object.rotation.z)
        vrm.scene.scale.set(object.scale.x, object.scale.y, object.scale.z)
        this.updateBlendShape({ vrm, blendShape: object.blendShape, delta })
        this.updatePose({ vrm, pose: object.pose, delta })
        
        docId = object.id

        vrm.scene.visible = object.isInvisible ? false : true
      }

      // materialの発光度を調整 (動かないので保留)
      // this.setEmissiveToVRM({
      //   vrm,
      //   materials: gltf.userData.vrmMToonMaterials,
      //   delta,
      //   emissive: { intensity: 0.2 }
      // })

      // materialのアウトラインなどの調整
      this.setOutlineToVRM({
        vrm,
        materials: vrm.materials, // gltf.userData.vrmMToonMaterials,
        delta,
        outlineWidth: (object && object.vrmOutlineWidth) ? 
          object.vrmOutlineWidth : 0.00075,
        // outlineWidth: { cloth: 0.0015, hair: 0.001, skin: 0.0015 },
        color: { r: 0, g: 0, b: 0, a: 0 }
      })

      vrm.scene.userData = { asset, docId, vrm }
      this.scene.add(vrm.scene)
      vrm.asset = asset
      
      if (object) {
        this.loadEffects({ object, sceneObject: vrm.scene })
        this.loadAddedCustomTextures({ objectDoc: object, vrm })
        const delta = this.clock.getDelta()
        if (object.hairWind) {
          this.updateHairWind({
            vrm: vrm,
            delta,
            params: {
              vec: this.toVector3(object.hairWind.vec),
              euler: this.toEuler3XYZ(object.hairWind.euler),
              windForce: object.hairWind.force
            }
          })
        }
        if (object.isHidingEyes) await this.hideEyes({ vrm, delta })
      }
      
      if (!isDropped && object) this.deactivateLoadingStatusInObjectList(object.id)
      return vrm.scene
    },
    async add3DObject ({ asset, target, object, isDropped }) {
      if (!isDropped && object) this.activateLoadingStatusInObjectList(object.id)

      const progressFunc = progress => {
        const progressPercent = Math.floor(100.0 * (progress.loaded / progress.total))
        this.assetLoadingProgresses.map(e => {
          if (e.assetId === asset.id) e.progress = progressPercent
          return e
        })
      }
      let gltf = await this.loadGLTFwithDracoLoader({ path: asset.assetURL, progressFunc })
      // gltf.scene = this.mergeObject(gltf.scene)
      const emissiveColor = (object && (object.emissiveColor || object.emissiveColor === 0)) ? 
        object.emissiveColor : 0x666666
      gltf.scene = this.mergeObjectByModelSize({ object: gltf.scene, emissiveColor })

      // SelectiveOutlineEffectで線画描写をするオブジェクトとして有効化する
      gltf.scene.traverse(node => node.applyOutline = true)
      // gltf.scene.traverse(node => node.visible = false)
      // window.model = gltf.scene

      // CustomOutlineV2用
      // this.addSurfaceIdAttributeToMesh(gltf.scene)

      // transformの基準点を中心に変えるためにモデルを囲うグループを作成
      // デフォルトでモデルの位置が中心になっていないモデル対応
      const wrapGLTFGroup = new THREE.Group()
      wrapGLTFGroup.add(gltf.scene)

      // 衝突判定用のboxを追加
      this.addMargineBoxForRaycaster(wrapGLTFGroup, 'gltf')
      // this.addMargineBoxForRaycaster(gltf.scene, 'gltf')

      let positionOffset
      if (asset.positionOffset) {
        positionOffset = asset.positionOffset
      } else {
        positionOffset = { x: 0, y: 0, z: 0 }
      }
      
      // 3dモデルに線画を追加
      let lineGroupWrapper
      if (asset.defaultLineSegmentsThrehold) {
        const edgeDegreeThrehold = (asset.defaultLineSegmentsThrehold) ?
          asset.defaultLineSegmentsThrehold : 20
        const lineGroup = this.createLineGeometoryToGroup({ 
          group: wrapGLTFGroup, edgeDegreeThrehold
        })
        // lineGroup.position.set(
        //   -positionOffset.x,
        //   -positionOffset.y,
        //   -positionOffset.z
        // )
        lineGroupWrapper = new THREE.Group()
        lineGroupWrapper.userData.modelUuid = wrapGLTFGroup.uuid
        // lineGroup.scale.set(1.01, 1.01, 1.01)
        lineGroupWrapper.add(lineGroup)
      
        wrapGLTFGroup.userData.lineGroupUuid = lineGroupWrapper.uuid
      }

      let docId
      if (isDropped) {
        // ドラッグ&ドロップで新規作成した場合
        // 初期の横幅を1.0に揃える
        const box = new THREE.Box3().setFromObject(gltf.scene)
        const wSize = box.max.x - box.min.x
        const hSize = box.max.y - box.min.y
        let initialSize = 1.0
        if (asset.type === '3d_stage') initialSize = this.initialSize3dStage
        if (asset.type === '3d_object') initialSize = this.initialSize3dObject
        const initialScale = initialSize / wSize

        // 子のgltfにオフセットを適応
        gltf.scene.position.set(
          -positionOffset.x,
          -positionOffset.y,
          -positionOffset.z
        )
        // 床に近い場合は床に接触させて配置する
        const initialPosY = target.point.y
        if (Math.abs(this.horizonalFloor.position.y - initialPosY) < 1) {
          // console.log('set on floor')
          wrapGLTFGroup.position.set(
            target.point.x,
            this.horizonalFloor.position.y + hSize/2 * initialScale,
            target.point.z)
        } else {
          // console.log('set target point', target.point)
          wrapGLTFGroup.position.copy(target.point)
          // wrapGLTFGroup.position.set(target.point.x, initialPosY, target.point.z)
        }
        // wrapGLTFGroup.position.set(target.point.x, target.point.y, target.point.z)
        wrapGLTFGroup.scale.set(initialScale, initialScale, initialScale)

        let gltfObj = {
          assetId: asset.id,
          position: this.toPosition(wrapGLTFGroup.position), // { x: 0, y: 0, z: 0 },
          rotation: this.toRotation(wrapGLTFGroup.rotation), // { x: 0, y: 0, z: 0 },
          scale: this.toScale(wrapGLTFGroup.scale),
          createdBy: this.uid,
          createdAt: new Date(), updatedAt: new Date()
        }
        if (asset.defaultEmissiveColor) {
          gltfObj.emissiveColor = asset.defaultEmissiveColor
        }
        docId = await this.objectCollection.add(gltfObj)
        gltfObj.id = docId
        this.objects.push(gltfObj)

        // 他のオブジェクトがなければシーンの明るさを最適化する
        // if (this.objects.length === 1 && asset.defaultAmbientLight) {
        //   this.ambientLight.intensity = asset.defaultAmbientLight.intensity
        // }
      } else if (object && !isDropped) {
        // object collectionからロードした場合
        // 子のgltfにオフセットを適応
        gltf.scene.position.set(
          -positionOffset.x,
          -positionOffset.y,
          -positionOffset.z
        )
        wrapGLTFGroup.position.set(object.position.x, object.position.y, object.position.z)
        wrapGLTFGroup.rotation.set(object.rotation.x, object.rotation.y, object.rotation.z)
        wrapGLTFGroup.scale.set(object.scale.x, object.scale.y, object.scale.z)
        docId = object.id

        wrapGLTFGroup.visible = object.isInvisible ? false : true
      }

      wrapGLTFGroup.userData = { asset, docId }
      this.scene.add(wrapGLTFGroup)

      if (lineGroupWrapper) {
        // lineGroupのスケールはgltfのスケールが設定されてから合わせないとbox3の関係で大きさがずれる
        lineGroupWrapper.userData.isLineGroupAttachedTo3DModel = true
        lineGroupWrapper.position.copy(wrapGLTFGroup.position)
        lineGroupWrapper.scale.copy(wrapGLTFGroup.scale)
        lineGroupWrapper.rotation.copy(wrapGLTFGroup.rotation)
        this.scene.add(lineGroupWrapper)
        this.lineGroupsForOutline.push(lineGroupWrapper)
      }

      if (asset.defaultEmissiveColor) {
        this.updateMaterialEmissive({
          object: gltf.scene,
          emissiveColor: asset.defaultEmissiveColor
        })
      }

      // effectをロード
      this.loadEffects({ object, sceneObject: wrapGLTFGroup })
      
      if (!isDropped && object) this.deactivateLoadingStatusInObjectList(object.id)
      return wrapGLTFGroup
    },
    addMargineBoxForRaycaster (sceneModel, format) {
      // raycansterの当たり判定用のボックスを追加
      const box3 = new THREE.Box3().setFromObject(sceneModel)
      const cubeSize = box3.getSize(new THREE.Vector3())
      // const cubeGeom = new THREE.BoxGeometry(cubeSize.x / 2, cubeSize.y, cubeSize.z / 2)
      const cubeSizeX = format === 'vrm' ? cubeSize.x * 0.5 : cubeSize.x * 0.8
      const cubeSizeZ = format === 'vrm' ? cubeSize.z * 0.5 : cubeSize.z * 0.8
      const cubeGeom = new THREE.BoxGeometry(cubeSizeX, cubeSize.y, cubeSizeZ)
      const cubeMat = new THREE.MeshBasicMaterial({color: 0x00ff00})
      const cubeMesh = new THREE.Mesh(cubeGeom, cubeMat)
      cubeMesh.visible = false
      if (format === 'vrm') cubeMesh.position.y = cubeSize.y / 2

      const boxGroup = new THREE.Group()
      boxGroup.position.copy(sceneModel.position)
      boxGroup.rotation.copy(sceneModel.rotation)
      boxGroup.scale.copy(sceneModel.scale)
      boxGroup.add(cubeMesh)
      this.scene.add(boxGroup)
      this.bCubes.push(cubeMesh)
      this.bCubeGroups.push(boxGroup)
      cubeMesh.userData = { attachedObjectUuid: sceneModel.uuid, isBCube: true }
      boxGroup.userData = { innerObjectUuid: sceneModel.uuid, isBCubeGroup: true }
    },
    async addSpriteImage ({ asset, target, object, isDropped }) {
      if (!isDropped && object) this.activateLoadingStatusInObjectList(object.id)

      const spriteTexture = new THREE.TextureLoader().load(asset.defaultImg)
      const spriteMat = new THREE.SpriteMaterial({map: spriteTexture})
      const sprite = new THREE.Sprite(spriteMat)
      const image = await this.loadImage(asset.defaultImg)

      // const halfHeight = target.distance / Math.tan(this.camera.fov/2 * Math.PI/180)
      // const scaleY = halfHeight * 2
      // const scaleX = scaleY * image.width / image.height
      // sprite.scale.set(scaleX, scaleY, 1)

      const baseSizeForScaling = ['background', 'effect_background'].includes(asset.type) ?
        this.stageSize : this.stageSize / 11
      
      const scaleX = baseSizeForScaling / 2
      const scaleY = scaleX * image.height / image.width
      sprite.scale.set(scaleX, scaleY, 1)
      
      let docId
      if (isDropped) {
        // ドラッグ&ドロップで新規作成した場合
        sprite.position.copy(target.point)
        const backgroundObj = {
          assetId: asset.id,
          position: this.toPosition(target.point), // { x: 0, y: 0, z: 0 },
          rotation: 0.0,
          scale: { x: 1, y: 1, z: 1 },
          defaultScaleForSpriteSize: { x: scaleX, y: scaleY, z: 1 },
          createdBy: this.uid,
          createdAt: new Date(), updatedAt: new Date()
        }
        docId = await this.objectCollection.add(backgroundObj)
        backgroundObj.id = docId
        this.objects.push(backgroundObj)
      } else if (object && !isDropped) {
        // object collectionからロードした場合
        sprite.position.set(object.position.x, object.position.y, object.position.z)
        sprite.material.rotation = object.rotation
        const defaultScale = object.defaultScaleForSpriteSize
        const scale = object.scale
        sprite.scale.set(defaultScale.x * scale.x, defaultScale.y * scale.y, defaultScale.z * scale.z)
        docId = object.id

        sprite.visible = object.isInvisible ? false : true
      }

      sprite.userData = { asset, docId }
      this.scene.add(sprite)
      this.sprites.push(sprite)

      this.loadEffects({ object, sceneObject: sprite })

      if (isDropped) this.targetObject = sprite

      if (!isDropped && object) this.deactivateLoadingStatusInObjectList(object.id)
      return sprite
    },
    // for list loading
    activateLoadingStatusInObjectList (objectDocId) {
      this.loadingStatusesInObjectList.push({
        objectDocId, isLoading: true
      })
    },
    deactivateLoadingStatusInObjectList (objectDocId) {
      this.loadingStatusesInObjectList = this.loadingStatusesInObjectList
        .map(l => {
          if (l.objectDocId === objectDocId) l.isLoading = false
          return l
        })
    },
    // events on canvas
    async onCanvas (event) {
      // キャプチャモードの時はレイキャストは飛ばさない
      if (this.isCapturing) return

      // 一定時間以上ドラッグしていた場合は処理しない（普通に角度だけ調整していることが多い）
      const gapFromClickStart = new Date()  - this.clickStartTime
      if (gapFromClickStart > 500) return

      // touchstartはtargetTouches、touchendはchangedTouches
      // const e = event.targetTouches ? event.targetTouches[0] : event
      const e = event.changedTouches ? event.changedTouches[0] : event
      const position = new THREE.Vector2()
      position.x = (e.clientX / window.innerWidth) * 2 - 1
      position.y = -(e.clientY / window.innerHeight) * 2 + 1

      // this.raycaster = new THREE.Raycaster()
      // this.raycaster.near = 0.1
      // this.raycaster.far = 50
      this.raycaster.setFromCamera(position, this.camera)

      const targetCandidates = this.bCubes.concat(this.sprites)
      let intersects = this.raycaster.intersectObjects(targetCandidates)
      // ロック or 非表示のオブジェクトは除外する
      intersects = intersects.filter(i => {
        if (i.object.userData.isBCube) {
          const targetBGroup = i.object.parent
          const innerObject = this.scene.children
            .filter(c => c.uuid === targetBGroup.userData.innerObjectUuid)[0]
          const objectDoc = this.objects
            .filter(o => o.id === innerObject.userData.docId)[0]
          return !objectDoc.isLocked && innerObject.visible
        } else {
          const objectDoc = this.objects
            .filter(o => o.id === i.object.userData.docId)[0]
          return !objectDoc.isLocked && i.object.visible
        }
      })
      if (!intersects[0]) {
        this.targetObject = null
        this.transformControls.detach()
        this.transformControlsForPose.detach()
        // if (this.dragControls) this.dragControls.deactivate()
        return
      }

      // vrm, 3d-objectの場合
      if (intersects[0].object.userData.isBCube) {
        // ItemObjectTransformChangerの
        // computedの変化でobjectPropsのwatchが発火してしまう問題をひとまずsleepで回避
        this.targetObject = null
        await this.sleep(100)
        const targetBGroup = intersects[0].object.parent
        this.targetObject = this.scene.children
          .filter(c => c.uuid === targetBGroup.userData.innerObjectUuid)[0]
      }

      // spriteの場合
      if (intersects[0].object.type === 'Sprite') {
        // ItemObjectTransformChangerの
        // computedの変化でobjectPropsのwatchが発火してしまう問題をひとまずsleepで回避
        this.targetObject = null
        await this.sleep(100)
        this.targetObject = intersects[0].object
      }

      if (this.targetObject) {
        // this.transformControls.attach(this.targetObject)
        this.transformControlsForPose.detach()
      }

      // transformControlsの適用
      this.attachTargetObjectToTransformControls()
    },
    // Sence Settings
    updateAmbientLightIntensity (intensity) {
      this.ambientLight.intensity = intensity
    },
    updateCameraFov (fov) {
      this.cameraFov = fov
      this.camera.setFocalLength(this.cameraFov)
      // this.camera.fov = this.cameraFov
      // this.camera.updateProjectionMatrix()
    },
    updateCameraNearFar (cameraNearFar) {
      this.cameraNearFar = cameraNearFar
      this.camera.near = this.cameraNearFar[0]
      this.camera.far = this.cameraNearFar[1]
      this.camera.updateProjectionMatrix()
    },
    updateSceneBackgroundColor (color) {
      this.renderer.setClearColor(color)
      this.renderer.currentClearColor = color
      // this.scene.background = color
    },
    // Manage documents
    async saveScene () {
      this.isSaving = true

      let sceneUpdate = {
        camera: {
          position: this.toPosition(this.camera.position),
          zoom: this.camera.zoom,
          fov: this.cameraFov, //this.camera.fov,
          nearFar: this.cameraNearFar
        },
        orbitControls: {
          position: this.toPosition(this.orbitControls.position0),
          target: this.toPosition(this.orbitControls.target)
        },
        light: {
          position: this.toPosition(this.light.position),
          color: this.toObjColor(this.light.color),
          intensity: this.ambientLight.intensity
        },
        ambientLight: {
          color: this.toObjColor(this.ambientLight.color),
          intensity: this.ambientLight.intensity
        },
        comicalShaderThrehold: [
          this.tonePass.uniforms['threholdColorLimit'].value.x,
          this.tonePass.uniforms['threholdColorLimit'].value.y
          // this.comicalConvertPass.uniforms['threholdColorLimit'].value.x,
          // this.comicalConvertPass.uniforms['threholdColorLimit'].value.y
        ]
      }
      
      if (this.renderer.currentClearColor) {
        sceneUpdate.backgroundColor = this.toObjColor(this.renderer.currentClearColor)
      }
      // if (this.scene.background) {
      //   sceneUpdate.backgroundColor = this.toObjColor(this.scene.background)
      // }
      
      const rp = this.$route.params
      await database.frameCollection(rp.comicId, rp.episodeId, rp.pageId)
        .update(this.frameId, { scene: sceneUpdate })
      // console.log('saveScene:', sceneUpdate)
      await this.sleep(1000)
      this.isSaving = false
    },
    setTargetObjectTransformProps (props) {
      const docId = this.targetObject.userData.docId
      if (this.targetObjectMode === 'sprite') {
        const objDoc = this.objects.filter(o => o.id === docId)[0]
        const defaultScale = objDoc.defaultScaleForSpriteSize
        this.targetObject.position.set(props.position.x, props.position.y, props.position.z)
        this.targetObject.material.rotation = props.rotation
        this.targetObject.scale
          .set(defaultScale.x * props.scale, defaultScale.y * props.scale, defaultScale.z * props.scale)        
      } else if (this.targetObjectMode === 'mesh') {
        this.targetObject.position.set(props.position.x, props.position.y, props.position.z)
        this.targetObject.rotation.set(props.rotation.x, props.rotation.y, props.rotation.z)
        this.targetObject.scale.set(props.scale, props.scale, props.scale)
      }

      // 7秒間値に変化がなければ保存
      if (this.updateTargetObjectTimer
        && this.updateTargetObjectTimer.docId === docId) {
        clearTimeout(this.updateTargetObjectTimer.timer)
      }
      
      const updateDocByObject = (object) => {
        this.updateTargetObject(object)
      }
      const timer = setTimeout(updateDocByObject,
        this.saveDuration, this.targetObject)
      this.updateTargetObjectTimer = { docId, timer }
    },
    updateBoneProp (bonesProps) {
      if (!this.targetObject.userData.vrm) return

      const delta = this.clock.getDelta()
      this.updatePose({ 
        vrm: this.targetObject.userData.vrm,
        pose: bonesProps,
        delta
      })

      // 目以外のボーンを更新
      const docId = this.targetObject.userData.docId
      const targetObjectDoc = this.objects.filter(o => o.id === docId)[0]
      targetObjectDoc.pose = targetObjectDoc.pose.map(bone => {
        if (!['LeftEye', 'RightEye'].includes(bone.name)) {
          const targetBone = bonesProps.filter(bp => bp.name === bone.name)[0]
          if (targetBone) bone.rotation = targetBone.rotation
        }
        return bone
      })

      // 7秒間値に変化がなければ保存
      if (this.updatePoseTimer
        && this.updatePoseTimer.docId === docId) {
        clearTimeout(this.updatePoseTimer.timer)
      }
      // const timer = setTimeout(() => {
      //   this.updateTargetObject(this.targetObject, { pose: targetObjectDoc.pose })
      // }, this.saveDuration)
      const updateDocByObject = (object, opt) => {
        this.updateTargetObject(object, opt)
      }
      const timer = setTimeout(updateDocByObject,
        this.saveDuration, this.targetObject, { pose: targetObjectDoc.pose })
      this.updatePoseTimer = { docId, timer }
    },
    updateEyesBoneProp (eyesBoneProps) {
      if (!this.targetObject.userData.vrm) return

      const delta = this.clock.getDelta()
      this.updatePose({ 
        vrm: this.targetObject.userData.vrm,
        pose: eyesBoneProps,
        delta
      })

      // 目のみのボーンを更新
      const leftEytBone = eyesBoneProps.filter(bone => bone.name === 'LeftEye')[0]
      const rightEytBone = eyesBoneProps.filter(bone => bone.name === 'RightEye')[0]

      const docId = this.targetObject.userData.docId
      const targetObjectDoc = this.objects.filter(o => o.id === docId)[0]
      targetObjectDoc.pose = targetObjectDoc.pose.map(bone => {
        if ('LeftEye' === bone.name) bone.rotation = leftEytBone.rotation
        if ('RightEye' === bone.name) bone.rotation = rightEytBone.rotation
        return bone
      })

      // 7秒間値に変化がなければ保存
      if (this.updateEyesBoneTimer
        && this.updateEyesBoneTimer.docId === docId) {
        clearTimeout(this.updateEyesBoneTimer.timer)
      }
      const updateDocByObject = (object, opt) => {
        this.updateTargetObject(object, opt)
      }
      const timer = setTimeout(updateDocByObject,
        this.saveDuration, this.targetObject, { pose: targetObjectDoc.pose })
      this.updateEyesBoneTimer = { docId, timer }
    },
    updateBlendShapeProp (blendShapeProps) {
      if (!this.targetObject.userData.vrm) return

      const delta = this.clock.getDelta()
      this.updateBlendShape({ 
        vrm: this.targetObject.userData.vrm,
        blendShape: blendShapeProps,
        delta
      })

      const docId = this.targetObject.userData.docId
      const targetObjectDoc = this.objects.filter(o => o.id === docId)[0]
      targetObjectDoc.blendShape = blendShapeProps

      // 7秒間値に変化がなければ保存
      // if (this.updateBlendShapeTimer) clearTimeout(this.updateBlendShapeTimer)
      // this.updateBlendShapeTimer = setTimeout(() => {
      //   this.updateTargetObject(this.targetObject, { blendShape: blendShapeProps })
      // }, this.saveDuration)
      if (this.updateBlendShapeTimer
        && this.updateBlendShapeTimer.docId === docId) {
        clearTimeout(this.updateBlendShapeTimer.timer)
      }
      // const timer = setTimeout(() => {
      //   this.updateTargetObject(this.targetObject, { blendShape: blendShapeProps })
      // }, this.saveDuration)
      // this.updateBlendShapeTimer = { docId, timer }
      const updateDocByObject = (object, opt) => {
        this.updateTargetObject(object, opt)
      }
      const timer = setTimeout(updateDocByObject,
        this.saveDuration, this.targetObject, { blendShape: blendShapeProps })
      this.updateBlendShapeTimer = { docId, timer }
    },
    loadEffects ({ object, sceneObject }) {
      if (object && object.opacity) {
        this.addObjectOpacityEffect({
          opacity: object.opacity,
          targetObject: sceneObject,
          isLoaded: true
        })
      }
      if (object && object.outline) {
        this.addObjectOutlineEffect({
          outline: object.outline,
          targetObject: sceneObject,
          isLoaded: true
        })
      }
    },
    async loadAddedCustomTextures ({ objectDoc, vrm }) {
      if (objectDoc.addedCustomTexture) {
        for (let i=0; i < objectDoc.addedCustomTexture.length; i++) {
          const textureName = objectDoc.addedCustomTexture[i]
          await this.addCustomTextureToVRM({
            vrm, delta: this.clock.getDelta(), addingTextureName: textureName
          })
        }
      }
    },
    addObjectOpacityEffect ({ opacity, targetObject, isLoaded }) {
      if (targetObject.type === 'Sprite') {
        targetObject.material.opacity = opacity
      } else {
        targetObject.opacity = opacity
      }
      // collectionからロードされた時はアップデートしない
      if (!isLoaded) this.objectCollection.update(targetObject.userData.docId, { opacity })
    },
    // unused function
    updateObjectOpacityEffect ({ opacity, targetObject }) {
      if (targetObject.type === 'Sprite') {
        targetObject.material.opacity = opacity
      } else if (targetObject.type === 'Group') {
        // targetObject.traverse(node => {
        //   if (node.transparent && node.material) {
        //     node.transparent = opacity
        //     node.material = opacity
        //   }
        // })
        // if (targetObject.userData.vrm) {
        //   const vrm = targetObject.userData.vrm
        //   vrm.materials.map(m => {
        //     if (m.transparent && m.opacity) {
        //       m.transparent = opacity
        //       m.material = opacity
        //     }
        //     return m
        //   })
        //   const delta = this.clock.getDelta()
        //   targetObject.userData.vrm.update(delta)
        // }
      } else if (targetObject.type === 'Mesh') {
        // targetObject.opacity = opacity
      }
      this.objectCollection.update(targetObject.userData.docId, { opacity })
    },
    removeObjectOpacityEffect (targetObject) {
      if (targetObject.type === 'Sprite') {
        targetObject.material.opacity = 1.0
      } else {
        // targetObject.opacity = 1.0
      }
      const objectDoc = this.objects
        .filter(o => o.id === targetObject.userData.docId)[0]
      delete objectDoc.opacity
      this.objectCollection.deleteField(targetObject.userData.docId, 'opacity')
    },
    addObjectOutlineEffect ({outline, targetObject, isLoaded}) {
      const pixelRatio = this.renderer.getPixelRatio()
      const outlinePass = new OutlinePass(
        new THREE.Vector2(this.canvasSize.width * pixelRatio, this.canvasSize.height * pixelRatio),
        this.scene, this.camera
      )
      outlinePass.selectedObjects = [targetObject]
      outlinePass.renderToScreen = true

      this.composer.addPass(outlinePass)

      outlinePass.edgeStrength = outline.edgeStrength
      outlinePass.edgeGlow = outline.edgeGlow
      outlinePass.visibleEdgeColor.set(`rgb(${outline.visibleEdgeColor}, ${outline.visibleEdgeColor}, ${outline.visibleEdgeColor})`)
      outlinePass.hiddenEdgeColor.set('rgb(0, 0, 0)')
      
      this.outlinePasses.push({id: targetObject.userData.docId, outlinePass})
      this.objects = this.objects.map(o => {
        if (o.id === targetObject.userData.docId) o.outline = outline
        return o
      })
      // collectionからロードされた時はアップデートしない
      if (!isLoaded) this.objectCollection.update(targetObject.userData.docId, { outline })
    },
    updateObjectOutlineEffect ({ outline, targetObject }) {
      const targetOutline = this.outlinePasses.filter(o => o.id === targetObject.userData.docId)[0]
      if (targetOutline) {
        const outlinePass = targetOutline.outlinePass
        outlinePass.edgeStrength = outline.edgeStrength
        outlinePass.edgeGlow = outline.edgeGlow
        outlinePass.visibleEdgeColor = new THREE.Color(`rgb(${outline.visibleEdgeColor}, ${outline.visibleEdgeColor}, ${outline.visibleEdgeColor})`)
        this.objectCollection.update(targetObject.userData.docId, { outline })
      }
    },
    removeObjectOutlineEffect (targetObject) {
      const targetOutline = this.outlinePasses.filter(o => o.id === targetObject.userData.docId)[0]
      if (targetOutline) {
        this.composer.removePass(targetOutline.outlinePass)
        this.outlinePasses = this.outlinePasses.filter(o => o.id !== targetObject.userData.docId)
        this.objects = this.objects.map(o => {
          if (o.id === targetObject.userData.docId) o.outline = null
          return o
        })
        this.objectCollection.deleteField(targetObject.userData.docId, 'outline')
      }
    },
    updateEmissiveColor ({ emissiveColor, targetObject }) {
      this.updateTargetObject(targetObject, { emissiveColor })
    },
    updateVrmOutlineWidth ({ vrmOutlineWidth, targetObject }) {
      this.updateTargetObject(targetObject, { vrmOutlineWidth })
    },
    async updateTargetObject (object, opt) {
      if (!object) return

      // 更新した直後に削除するとすでに削除されたdocumentをアップデートしようとしてしまう
      const docId = object.userData.docId
      const objectExistingInObjects = this.objects.filter(o => o.id === docId)[0]
      if (!objectExistingInObjects) return

      this.isSaving = true
      // console.log('updateTargetObject:', object)
      // let params
      // if (this.targetObjectMode === 'mesh') {
      //   params = {
      //     position: this.toPosition(object.position),
      //     rotation: this.toRotation(object.rotation),
      //     scale: this.toScale(object.scale)
      //   }
      // } else if (this.targetObjectMode === 'sprite') {
      //   const scale = this.$refs.itemObjectTransformChanger.objectProps.scale
      //   const rotation = this.$refs.itemObjectTransformChanger.objectProps.rotation
      //   params = {
      //     position: this.toPosition(this.targetObject.position),
      //     rotation: rotation,
      //     scale: { x: scale, y: scale, z: scale }
      //   }
      // }

      let params
      let saveAsMesh = [
        'actor', '3d_object', '3d_stage'
      ].includes(object.userData.asset.type)
      if (saveAsMesh) {
        params = {
          position: this.toPosition(object.position),
          rotation: this.toRotation(object.rotation),
          scale: this.toScale(object.scale)
        }
      } else {
        const itemObjectTransformChanger = this.$refs.itemObjectTransformChanger
        const scale = itemObjectTransformChanger.objectProps.scale
        const rotation = itemObjectTransformChanger.objectProps.rotation
        params = {
          position: this.toPosition(object.position),
          rotation: rotation,
          scale: { x: scale, y: scale, z: scale }
        }
      }

      this.objects = this.objects.map(objectDoc => {
        if (objectDoc.id === object.userData.docId) {
          objectDoc.position = params.position
          objectDoc.rotation = params.rotation
          objectDoc.scale = params.scale
          if (opt) {
            Object.keys(opt).forEach((key) => {
              objectDoc[key] = opt[key]
            })
          }
        }
        return objectDoc
      })
      
      if (opt) params = { ...params, ...opt }
      await this.objectCollection.update(object.userData.docId, params)

      await this.sleep(1000)
      this.isSaving = false
    },
    removeObject (object) {
      // console.log('object to delete:', object)
      this.transformControls.detach()
      this.transformControlsForPose.detach()
      
      if (object.type === 'Sprite') {
        // object.material.dispose()
        this.sprites = this.sprites.filter(s => s.uuid !== object.uuid)
      } else if (object.type === 'Group') {
        const outerBBoxGroup = this.bCubeGroups
          .filter(b => b.userData.innerObjectUuid === object.uuid)[0]
        if (outerBBoxGroup) {
          // if (outerBBoxGroup.children[0]) {
          //   outerBBoxGroup.children[0].material.dispose()
          //   outerBBoxGroup.children[0].geometry.dispose()
          //   this.scene.remove(outerBBoxGroup.children[0])
          // }
          this.scene.remove(outerBBoxGroup)
          this.bCubeGroups = this.bCubeGroups
            .filter(b => b.userData.innerObjectUuid !== object.uuid)
          this.bCubes = this.bCubes
            .filter(b => b.userData.attachedObjectUuid !== object.uuid)
        }

        const attachingObject = this.lineGroupsForOutline
          .filter(l => l.userData.modelUuid === object.uuid)[0]
        if (attachingObject) {
          this.scene.remove(attachingObject)
          this.lineGroupsForOutline = this.lineGroupsForOutline
            .filter(l => l.userData.modelUuid !== object.uuid)
        }
      }
      if (object.userData.vrm) {
        this.vrmDeepDispose(object.userData.vrm)
        this.scene.remove(object.userData.vrm)
        // console.log('remove vrm')
      }
      object.traverse(node => {
        this.disposeNode(node)
        this.scene.remove(node)
      })
      // this.scene.remove(object)

      if (this.targetObject && this.targetObject.uuid === object.uuid) {
        this.targetObject = null
      }

      const docId = object.userData.docId
      this.objects = this.objects.filter(o => o.id !== docId)

      this.objectCollection.delete(docId)
    },
    updateObjectDoc ({ docId, fieldName, fieldValue }) {
      const objectDoc = this.objects.filter(o => o.id === docId)[0]
      objectDoc[fieldName] = fieldValue
      let params = {}
      params[fieldName] = fieldValue
      // console.log('updateObjectDoc:', { ...params })
      this.objectCollection.update(docId, params)
    },
    deleteObjectDocField ({ docId, fieldName }) {
      const objectDoc = this.objects.filter(o => o.id === docId)[0]
      delete objectDoc[fieldName]
      this.objectCollection.deleteField(docId, fieldName)
    },
    // アセットが削除された時に配置されたオブジェクトも削除する
    deleteObjectsOfAsset ({ assetId }) {
      let objectsToDelete = []
      for (let i=0; i<this.scene.children.length; i++) {
        const child = this.scene.children[i]
        if (child.userData.asset
          && child.userData.asset.id === assetId) {
          objectsToDelete.push(child)
        }
      }
      objectsToDelete.map(o => { this.removeObject(o) })
    },
    setObjectInvisible ({ objectDocId, isInvisible }) {
      this.objects = this.objects.map(o => {
        if (o.id === objectDocId) o.isInvisible = isInvisible
        return o
      })
      const sceneObject = this.scene.children
        .filter(c => c.userData.docId === objectDocId)[0]
      sceneObject.visible = !isInvisible
      this.objectCollection
        .update(objectDocId, { isInvisible: isInvisible })
    },
    setObjectLocked ({ objectDocId, isLocked }) {
      this.objects = this.objects.map(o => {
        if (o.id === objectDocId) o.isLocked = isLocked
        return o
      })
      const sceneObject = this.scene.children
        .filter(c => c.userData.docId === objectDocId)[0]
      this.objectCollection
        .update(objectDocId, { isLocked: isLocked })      
    },
    toggleTonePass (enableColor) {
      if (enableColor) this.removeTonePass()
      else this.addTonePass()

      localStorage.setItem('enableColorInStudio', 
        enableColor ? 'color' : 'mono')
    },
    keydown (e) {
      if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) {
        switch (e.key) {
          case 'c':
            // console.log('copy')
            break
          case 'v':
            // console.log('paste')
            break
          case '.':
          case '\\':
            this.showUI = !this.showUI
            break
        }
        // console.log(e.key)
      } else {
        // ツールの変更
        switch (e.key) {
          case 'v':
            this.setTranformControlsMode('normal')
            break
          case 't':
            this.setTranformControlsMode('translate')
            break
          case 'r':
            this.setTranformControlsMode('rotate')
            break
        }
      }
    }
  }
}
</script>
